import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import classnames from "classnames";

import { withTranslation } from "react-i18next";

import FormBrochure from "./FormReportConf";
import PDFViewer from "components/Common/PDFViewer/PDFViewer";
import { useDispatch, useSelector } from "react-redux";
import { getBrochureList } from "../../store/Reports/actions";
import BrochureList from "./brochureList";
const Brochure = props => {

  document.title = "Brochure | Municipio Transparente";

  const dispatch = useDispatch()

  const [brochureModalShow, setBrochureModalShow] = useState(false);

  const handleBrochureModal = () => {
    setBrochureModalShow(!brochureModalShow);
  };

  const { brochure } = useSelector(state => ({
    brochure: state.ReportsReducer.brochure,
  }));

  useEffect(() => {
    if (brochure) {
      setBrochureModalShow(true);
    } else {
      setBrochureModalShow(false);
    }
  }, [brochure]);
    const [activeTab, setactiveTab] = useState("1");

  const toggle = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
    if( tab === "2" ) {
      dispatch(getBrochureList(''))
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Reportes")}
            breadcrumbItem={props.t("Brochure")}
          />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col xs="12">
                      <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        Generar Brochure
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        Brochures Generados
                      </NavLink>
                    </NavItem>
                  
                  </Nav>
                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <Row>
                        <Col xs="12">
                          <FormBrochure />
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2">
                      <BrochureList />
                    </TabPane>
                    </TabContent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <PDFViewer docData={brochure} isOpen={brochureModalShow} toggle={handleBrochureModal} />
        </Container>
      </div>
    </React.Fragment>
  );
};


export default withTranslation()(Brochure);
